import React from 'react'

import { BaseIconProps, IconSizes, IconColors } from '../base'

const Information: React.FC<BaseIconProps> = React.forwardRef(
  ({ size = 'md', color = 'default', className }, ref) => (
    <svg
      ref={ref}
      className={className}
      width={IconSizes[size]}
      height={IconSizes[size]}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z"
        stroke={IconColors[color]}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.00024 9.99946V5.63855"
        stroke={IconColors[color]}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="7.01856"
        cy="4.13126"
        rx="0.46875"
        ry="0.46875"
        fill={IconColors[color]}
      />
      <circle cx="6.96875" cy="4.0625" r="0.5" fill={IconColors[color]} />
    </svg>
  ),
)

export default Information
